<template>
    <transition name="slide-out">
        <div class="extra-info-slide" v-if="moreInfo.nodes.length > 0">
            <div class="slide-nav">
                <h4>{{moreInfo.name}}</h4>
                <i class="fal fa-times close-button fa-2x" v-on:click="moreInfo.nodes=[]"></i>
            </div>
            
            <div class="slide-body">
                <div v-if="moreInfo.description">
                    <div v-html="moreInfo.description"></div>
                </div>
                <div v-if="moreInfo.website">
                    <h6>Website: </h6>
                    <a class="blue-link" v-bind:href="moreInfo.website" target="_blank" rel="noopener noreferrer"><i class="fal fa-globe fa-lg"></i> {{ moreInfo.website }}</a>
                    <p v-for='link in moreInfo.other_links' v-bind:key="link.id" class="blue-link"><a v-bind:href="link.url" target="_blank">{{ link.link_text }}</a></p>
                </div>
                <div v-if="moreInfo.address">
                    <h6>Address:</h6> {{ moreInfo.address }}
                </div>
                <br>
                <div v-if="moreInfo.nodes">
                    <h6>Accepted Items:</h6>
                    <ul>
                        <li v-for="node in moreInfo.nodes" v-bind:key="node.id" :class="['list-depth-'+node.depth, {'hide-cat': hideCat(node.depth)}]">{{node.name}}</li>
                    </ul>
                </div>
            </div>
        </div>
        </transition>
</template>

<script>
export default {
    name: 'SlideOut',
    data() {
        return {
        }
    },
    props: {
        moreInfo: {
            type: Object
        }
    },
    computed: {
        onlyCat() {
            let count = 0;
            for (let n in this.moreInfo.nodes) {
                if (this.moreInfo.nodes[n].depth == 2) {
                    count++;
                }
            }
            if (count <= 1) {
                return true;
            }
            return false
        }
    },
    methods: {
        hideCat(depth) {
            if (depth == 2 && this.onlyCat) {
                return true;
            }
             return false;
        }
    }
}
</script>

<style scoped>

.blue-link a {
    color: #3672a5;
}

h6 {
    margin-bottom: .5rem;
}

ul{
    margin-top: 2rem;
}

li.list-depth-2 {

}

li.list-depth-3 {
    list-style-type: disc;
    list-style-position: inside;
    margin-left: 2rem;
}

li.hide-cat {
    display: none;
}

.extra-info-slide {
    position: fixed;
    width: 85%;
    max-width: 500px;
    right: 0;
    overflow-x: scroll;
    /* height: 100vh; */
    bottom: 0;
    background: #fff;
    padding: 2rem 2rem 3rem 2rem;
    /* display: flex; */
    z-index: 4;
    top: 0;
}

.slide-nav{
    position: relative;
    min-height: 4rem;
}

.slide-nav h4{
    max-width: 85%;
}

.close-button{
    position: absolute;
    right: 0;
    top: 0;
}

/* i{
    cursor: pointer;
    font-size: 3rem;
} */

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-out-enter-active {
  transition: all .75s ease;
}
.slide-out-leave-active {
  transition: all .25s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  /* position: absolute; */
}
.slide-out-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
  /* opacity: 0; */
}

.slide-out-leave-to{
    /* position: absolute; */
    transform: translateX(100%);
}


@media (min-width: 1025px){
   .extra-info-slide{
      padding: 3rem 4rem 3rem 4rem;
   }
      
}

</style>